var exports = {
  "qr": "footer__9gRDKx",
  "bL": "footerWrapper__vtL0SV",
  "JU": "footerButtonWrapper__tJ-7L0",
  "od": "childrenStyling__k3JZmY",
};

module.exports = exports;
